export default __webpack_public_path__ + "assets/front/scss/formulaire.d59bbcd56fe2991a19ad4ecf4a2c2661.css";